import React from 'react';
import i18n from 'util/i18n';
import { Modal } from 'components/Modal';
import './HipaaOptionalConfirmationModal.scss';

const HipaaOptionalConfirmationModal = function ({
  handleHipaaCancel, handleHipaaDismiss, show
}) {
  return (
    <Modal className="hipaa-confirmation__modal" show={show}>
      <h3>{i18n.t('application.hipaaConfirmation.header')}</h3>
      {i18n.m('application.hipaaConfirmation.para')}

      <div className="text-right">
        <button type="button" onClick={handleHipaaCancel} className="submit usa-button-secondary">
          {i18n.t('application.hipaaConfirmation.back')}
        </button>
        <button type="button" onClick={handleHipaaDismiss} className="submit usa-button">
          {i18n.t('application.hipaaConfirmation.continue')}
        </button>
      </div>
    </Modal>
  );
};

export default HipaaOptionalConfirmationModal;
